import * as React from "react";

const SvgIcnNoData = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 72 72" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path
                d="M1 11h70V4c0-1.653-1.346-3-3-3H4C2.346 1 1 2.346 1 4v7zm0 1v56c0 1.653 1.346 3 3 3h64c1.653 0 3-1.346 3-3V12H1zM0 4c0-2.21 1.798-4 4-4h64c2.21 0 4 1.798 4 4v64c0 2.21-1.798 4-4 4H4c-2.21 0-4-1.798-4-4V4zm7 2a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0zm5 0a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0zm5 0a1 1 0 10-2 0 1 1 0 002 0zm1 0a2 2 0 11-4 0 2 2 0 014 0z"
                fill="currentColor"
                fillRule="nonzero"
            />
            <g transform="translate(0 43)" fillRule="nonzero" stroke="currentColor">
                <circle cx={12} cy={7} r={2} />
                <circle cx={36} cy={15} r={2} />
                <circle cx={60} cy={2} r={2} />
                <path d="M.5 15L10 8M38 14.5l20-12M14 8l20 6.5M61.5 2.5l10 4" />
            </g>
            <g transform="translate(11 22)" stroke="currentColor">
                <circle cx={8} cy={8} r={3.5} />
                <path d="M20.5 6.5h24" strokeLinecap="round" />
                <path d="M15.5 0v16" />
                <path d="M20.5 9.5h17" strokeLinecap="round" />
                <rect x={0.5} y={0.5} width={49} height={15} rx={3} />
            </g>
        </g>
    </svg>
);

export default SvgIcnNoData;
